import React from 'react'
import { FormattedMessage } from 'react-intl'

interface Props {
  surveyTitle: string
  /** First-timer path: start immediately, no account (request 2.1). */
  onTakeAsGuest: () => void
  /** Returning path: sign in to see history / retake (request 2.2). */
  onSignIn: () => void
}

/**
 * Request 2: the take landing handles two intents.
 * Guest-first is prominent and frictionless; sign-in is the secondary,
 * returning-user path shown at the start.
 */
const TakeLanding: React.FC<Props> = ({ surveyTitle, onTakeAsGuest, onSignIn }) => {
  return (
    <div className="space-y-6 text-center">
      <h1 className="text-2xl font-bold text-foreground">{surveyTitle}</h1>

      <button
        type="button"
        onClick={onTakeAsGuest}
        className="w-full bg-primary text-white font-semibold py-3 rounded-lg"
      >
        <FormattedMessage id="takeLanding.takeTest" />
      </button>
      <p className="text-sm text-foreground-muted"><FormattedMessage id="takeLanding.noAccount" /></p>

      <div className="pt-2 border-t border-border-light">
        <p className="text-sm text-foreground-muted mt-4">
          <FormattedMessage id="takeLanding.beenHereBefore" />{' '}
          <button type="button" onClick={onSignIn} className="text-primary font-medium underline">
            <FormattedMessage id="takeLanding.signInHistory" />
          </button>
        </p>
      </div>
    </div>
  )
}

export default TakeLanding
